import {
	CalendarOutlined,
	HomeOutlined,
	InboxOutlined,
	SafetyCertificateOutlined,
	SolutionOutlined,
} from '@ant-design/icons';

import { PATHS } from '../../AppDomains';

import type { FeatureFlagName } from '../../config/FeatureFlagNames';
import type { ReactNode } from 'react';

export const POPULATION_HEALTH_MANAGEMENT_TABS_FLAG_NAME =
	'configuration_PopulationHealth_tabs' as const satisfies FeatureFlagName;

export enum PopulationHealthManagementPage {
	Home = 'Home',
	SchedulingPatients = 'SchedulingPatients',
	PatientsWorkList = 'PatientsWorkList',
	CareGapWorkspace = 'CareGapWorkspace',
	Archive = 'Archive',
}

export interface PopulationHealthManagementPageData {
	readonly id: PopulationHealthManagementPage;
	readonly featureFlagName: string;
	readonly path: string;
	readonly label: string;
	readonly icon: ReactNode;
}

export const POPULATION_HEALTH_MANAGEMENT_PAGES = [
	{
		id: PopulationHealthManagementPage.Home,
		featureFlagName: 'Home',
		path: 'home',
		label: 'Home',
		icon: <HomeOutlined />,
	},
	{
		id: PopulationHealthManagementPage.SchedulingPatients,
		featureFlagName: 'SchedulingPatients',
		path: 'scheduling-patients',
		label: 'Scheduling patients',
		icon: <CalendarOutlined />,
	},
	{
		id: PopulationHealthManagementPage.PatientsWorkList,
		featureFlagName: 'PatientsWorkList',
		path: 'patients-work-list',
		label: 'Patients work list',
		icon: <SolutionOutlined />,
	},
	{
		id: PopulationHealthManagementPage.CareGapWorkspace,
		featureFlagName: 'CareGapWorkspace',
		path: 'care-gap-workspace',
		label: 'Care gap workspace',
		icon: <SafetyCertificateOutlined />,
	},
	{
		id: PopulationHealthManagementPage.Archive,
		featureFlagName: 'Archive',
		path: 'archive',
		label: 'Archive',
		icon: <InboxOutlined />,
	},
] as const satisfies ReadonlyArray<PopulationHealthManagementPageData>;

export type PopulationHealthManagementFeatureFlagId =
	(typeof POPULATION_HEALTH_MANAGEMENT_PAGES)[number]['featureFlagName'];

export function getPopulationHealthManagementPagePath(path: string): string {
	return `${PATHS.POPULATION_HEALTH_MANAGEMENT_PATH}/${path}`;
}

export function getAllowedPopulationHealthManagementPages(
	allowedFeatureFlagNames: ReadonlyArray<PopulationHealthManagementFeatureFlagId>,
): ReadonlyArray<PopulationHealthManagementPageData> {
	return allowedFeatureFlagNames
		.map(function findPageByFeatureFlagName(featureFlagName): PopulationHealthManagementPageData | undefined {
			return POPULATION_HEALTH_MANAGEMENT_PAGES.find(function matchPageFeatureFlagName(page): boolean {
				return page.featureFlagName === featureFlagName;
			});
		})
		.filter(function isKnownPage(
			page: PopulationHealthManagementPageData | undefined,
		): page is PopulationHealthManagementPageData {
			return page !== undefined;
		});
}
